import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

import type { SubscriptionPlan } from 'v2/interfaces/product';

import type { UseQueryOptions } from '@tanstack/react-query';

function useSubscriptionPlans(parentId: number, options: UseQueryOptions<SubscriptionPlan[]>) {
  return useQuery<SubscriptionPlan[]>(['product', parentId, 'plans'], () => productService.getPlans(parentId), options);
}

export { useSubscriptionPlans };
